import React, { FunctionComponent, h } from "preact"; // eslint-disable-line @typescript-eslint/no-unused-vars

export interface IErrorAlert {
  title: string;
  message: string;
}

const ErrorAlert: FunctionComponent<IErrorAlert> = ({ title, message }) => (
  <section className="alert-block alert-block--error">
    <div className="container">
      <div className="container__inner">
        <div className="alert-block__inner">
          <h2 className="alert-block__title">{title}</h2>
          <div className="alert-block__description">
            <p>{message}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default ErrorAlert;
